export const tryShareFile = async (blob: Blob, filename: string): Promise<boolean> => {
  if (typeof navigator.share !== 'function' || typeof navigator.canShare !== 'function') {
    return false
  }

  const file = new File([blob], filename, { type: 'application/pdf' })
  if (!navigator.canShare({ files: [file] })) {
    return false
  }

  try {
    await navigator.share({ files: [file] })
    return true
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      return true
    }
    return false
  }
}

export const triggerBlobDownload = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export const downloadOrSharePdf = async (blob: Blob, filename: string): Promise<void> => {
  const shared = await tryShareFile(blob, filename)
  if (!shared) {
    triggerBlobDownload(blob, filename)
  }
}
